import { Component, OnInit, ChangeDetectorRef, DestroyRef, inject , signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { SettingsService, Unit } from 'src/app/services/account/settings.service';
import { skip } from 'rxjs/operators';
import { UnitSettings } from 'src/app/models/unit-settings';
import { CommonModule } from '@angular/common';
import { SvgRecolorDirective } from 'src/app/directives/svg-recolor.directive';

@Component({
  standalone: true,
  selector: 'app-wind-panel',
  templateUrl: './wind-panel.component.html',
  imports: [CommonModule, SvgRecolorDirective],
  styleUrls: ['./wind-panel.component.scss']
})
export class WindPanelComponent implements OnInit {

  public readonly temperatureImg = signal<string>('');
  public readonly temperatureValue = signal<number>(0);
  public readonly temperatureValueText = signal<number>(0);
  public readonly temperatureUnit = signal<string>("°C");
  public readonly windDeg = signal<number>(0);
  public readonly windForce = signal<number>(0);
  public readonly windForceText = signal<number>(0);
  public readonly windUnit = signal<string>("km/h");
  private unit: UnitSettings = { Distance: Unit.Metric, Temperature: Unit.Metric, Speed: Unit.Metric, Pressure: Unit.Metric };

  private readonly destroyRef = inject(DestroyRef);

  constructor(private cdr: ChangeDetectorRef, private utilsService: UtilsService, public settingsService: SettingsService
  ) {
  }

  public setTemperature(temperature: number, weathercode: number, windDeg: number, windForce: number): void {
    this.temperatureValue.set(temperature);
    this.temperatureImg.set(this.utilsService.getWeatherImgById(weathercode) ?? '');
    this.windDeg.set(windDeg);
    this.windForce.set(windForce);
    this.setValues();
  }

  ngOnInit(): void {
    this.settingsService.ObservableUnit.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp) => {
      if (resp) {
        this.unit = resp;
        this.setValues();
      }
    });
  }

  private setValues(): void {
    if (this.unit.Temperature == Unit.Imperial) {
      this.temperatureUnit.set("°F");
      this.temperatureValueText.set(Math.round(this.utilsService.ConvertCelsiusToFahrenheit(this.temperatureValue())));
    }
    else {
      this.temperatureUnit.set("°C");
      this.temperatureValueText.set(Math.round(this.temperatureValue()));
    }

    if (this.unit.Speed == Unit.Imperial) {
      this.windUnit.set("mph");
      this.windForceText.set(Math.round(this.utilsService.kmphToMph(this.windForce())));
    }
    else {
      this.windUnit.set("km/h");
      this.windForceText.set(Math.round(this.windForce()));
    }
  }
}
